import { render, staticRenderFns } from "./CouponUpdateForm.vue?vue&type=template&id=2205f7c9&"
import script from "./CouponUpdateForm.vue?vue&type=script&lang=js&"
export * from "./CouponUpdateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports